import type React from 'react';

import { Box } from '@mui/material';

interface IconWrapperProps {
  children: React.ReactNode;
  size?: number;
}

const IconWrapper = ({ size = 32, children }: IconWrapperProps): React.ReactElement => (
  <Box
    display='flex'
    alignItems='center'
    justifyContent='center'
    sx={{
      color: 'inherit',
      width: size,
      height: size,
      flexShrink: 0,
      '& svg': {
        width: size,
        height: size,
      },
      '& img': {
        width: size,
        height: size,
        display: 'block',
      },
    }}
  >
    {children}
  </Box>
);

export default IconWrapper;
